import React from 'react'

export default function IconDataFeeds({
  size = '1em',
  style = {},
  fill = 'currentColor',
  ...rest
}) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      fill={fill}
      viewBox="0 0 50 50"
      {...rest}
    >
      <path
        fill={fill}
        fillRule="evenodd"
        d="M43.705 26.313C43.03 36.056 34.915 43.75 25 43.75 14.645 43.75 6.25 35.355 6.25 25c0-9.914 7.694-18.031 17.438-18.705.433-.03.87-.045 1.312-.045V25h18.75c0 .441-.015.879-.045 1.313zm-19.633-.385a1.313 1.313 0 01-.384-.928V7.611C14.67 8.282 7.563 15.811 7.563 25c0 9.63 7.807 17.438 17.437 17.438 9.189 0 16.718-7.108 17.389-16.125H25c-.348 0-.682-.139-.928-.385z"
        clipRule="evenodd"
      ></path>
      <path
        fill={fill}
        fillRule="evenodd"
        d="M28.094 14.688v-7.5c0-.336.252-.617.585-.653l.07.653-.07-.653H28.688l.016-.002.053-.005c.045-.003.109-.008.19-.011.162-.007.393-.012.682-.004.578.017 1.388.086 2.338.297 1.902.421 4.367 1.408 6.622 3.663 2.575 2.576 3.798 5.258 4.375 7.306.287 1.023.414 1.887.468 2.5a9.652 9.652 0 01.038.924l-.001.056v.017l-.001.005v.002s0 .002-.656-.033l.656.033a.658.658 0 01-.656.623H28.75a.656.656 0 01-.656-.656v-6.562zm1.312-6.867l.185.004c.509.015 1.236.077 2.092.266.633.14 1.336.35 2.073.662l-4.35 4.35V7.821zm0 11.845v-4.707l5.433-5.433a.657.657 0 00.127-.179 12.427 12.427 0 012.7 2.06c-.002 0-.004.002-.005.004l-8.255 8.255zm.928.928h4.706l5.433-5.433.01-.01a15.905 15.905 0 00-1.925-2.782l-8.224 8.225zm10.754-4.192l-4.192 4.192h5.245a12.482 12.482 0 00-.44-2.459 14.25 14.25 0 00-.613-1.733z"
        clipRule="evenodd"
      ></path>
    </svg>
  )
}
